import { useEffect, useState } from 'react'

import { Col, Form, Image, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { ArrowRightCircleFill } from 'react-bootstrap-icons'

import apinode from '../../../../../services/apinode'
import CategoriesService from '../../../../../services/database/CategoriesService'
import MarcasService from '../../../../../services/database/MarcasService'
import SubcategoriesService from '../../../../../services/database/SubcategoriesService'

import { sendErrorApiMessage } from '../../../../../utils/sendErrorApiMessage'

import { CustomSpinner } from '../../../../CustomSpinner'
import {
  ContainerComponent,
  ContentComponent,
  FooterComponent,
  NextButton,
} from '../../styles'

export function InformacoesGerais({
  isVisible,
  product,
  setProduct,
  handleChange,
  onNext,
  isEditPage,
}) {
  const [categories, setCategories] = useState([])
  const [isLoadingCategories, setIsLoadingCategories] = useState(true)

  const [subcategories, setSubCategories] = useState([])
  const [isLoadingSubcategories, setIsLoadingSubcategories] = useState(true)

  const [marcas, setMarcas] = useState([])
  const [isLoadingMarcas, setIsLoadingMarcas] = useState(true)

  const [contas, setContas] = useState([])
  const [isLoadingContas, setIsLoadingContas] = useState(true)

  async function loadCategories() {
    try {
      setIsLoadingCategories(true)
      const data = await CategoriesService.getAll()

      setCategories(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar as categorias!')
    } finally {
      setIsLoadingCategories(false)
    }
  }

  async function loadSubcategories() {
    try {
      setIsLoadingSubcategories(true)
      const data = await SubcategoriesService.getAll()

      setSubCategories(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar as subcategorias!')
    } finally {
      setIsLoadingSubcategories(false)
    }
  }

  async function loadMarcas() {
    try {
      setIsLoadingMarcas(true)
      const marcas = await MarcasService.getAll()

      setMarcas(marcas)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar as marcas!')
    } finally {
      setIsLoadingMarcas(false)
    }
  }

  async function loadAccounts() {
    try {
      setIsLoadingContas(true)

      const response = await apinode.get(
        `/pedido/contas/${localStorage.idconta}`,
      )

      setContas(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar contas!')
    } finally {
      setIsLoadingContas(false)
    }
  }

  useEffect(() => {
    if (isVisible) {
      loadCategories()
      loadSubcategories()
      loadMarcas()
      loadAccounts()
    }
  }, [isVisible])

  if (!isVisible) {
    return null
  }

  const imageUrl = `${process.env.REACT_APP_IMAGE_URL_API}/${product.IMG_CAPA ? product.IMG_CAPA : 'no-image.jpg'}`

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Informações Gerais</h4>

          {isEditPage && (
            <Row className="mb-3">
              <Image
                src={imageUrl}
                style={{
                  width: 300,
                  height: 200,
                }}
              />
            </Row>
          )}

          <Row className="mb-3">
            <Col>
              <Form.Label>Cód. Barras</Form.Label>
              <Form.Control
                name="CODBARRAS"
                value={product.CODBARRAS}
                onChange={(e) => handleChange(e, 'gerais')}
                disabled={product.UNIDADE === 'KIT'}
              />
            </Col>

            <Col>
              <Form.Label>Cód. Interno</Form.Label>
              <Form.Control
                name="CODINTERNO"
                value={product.CODINTERNO}
                onChange={(e) => handleChange(e, 'gerais')}
              />
            </Col>

            <Col>
              <Form.Label>SKU Principal</Form.Label>
              <Form.Control
                name="SKU_PRINCIPAL"
                value={product.SKU_PRINCIPAL}
                onChange={(e) => handleChange(e, 'gerais')}
              />
            </Col>

            {isEditPage && (
              <Col>
                <Form.Label>SKU</Form.Label>
                <Form.Control
                  name="SKU"
                  value={product.SKU}
                  onChange={(e) => handleChange(e, 'gerais')}
                />
              </Col>
            )}

            <Col>
              <Form.Label>Localização</Form.Label>
              <Form.Control
                name="LOCALIZACAO"
                value={product.LOCALIZACAO}
                onChange={(e) => handleChange(e, 'gerais')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Descrição *</Form.Label>
              <Form.Control
                name="DESCRICAO"
                value={product.DESCRICAO}
                onChange={(e) => handleChange(e, 'gerais')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  Categoria *
                </Form.Label>

                {isLoadingCategories && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="ID_CATEGORIA"
                value={product.ID_CATEGORIA}
                onChange={(e) => handleChange(e, 'gerais')}
                disabled={isLoadingCategories}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingCategories
                    ? 'Carregando...'
                    : 'Selecione uma categoria'}
                </option>
                {categories.map((category) => (
                  <option
                    key={category.id_categoria || category.ID_CATEGORIA}
                    value={category.id_categoria || category.ID_CATEGORIA}
                  >
                    {category.categoria || category.CATEGORIA}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  Sub-Categoria *
                </Form.Label>

                {isLoadingSubcategories && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="ID_SUBCATEGORIA"
                value={product.ID_SUBCATEGORIA}
                onChange={(e) => handleChange(e, 'gerais')}
                disabled={isLoadingSubcategories}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingSubcategories
                    ? 'Carregando...'
                    : 'Selecione uma sub-categoria'}
                </option>
                {subcategories.map((subcategory) => (
                  <option
                    key={
                      subcategory.id_subcategoria || subcategory.ID_SUBCATEGORIA
                    }
                    value={
                      subcategory.id_subcategoria || subcategory.ID_SUBCATEGORIA
                    }
                  >
                    {subcategory.subcategoria || subcategory.SUBCATEGORIA}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  Marca *
                </Form.Label>

                {isLoadingMarcas && <CustomSpinner size={18} />}
              </div>

              <Form.Select
                name="MARCA"
                value={product.MARCA}
                onChange={(e) => handleChange(e, 'gerais')}
                disabled={isLoadingMarcas}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingMarcas ? 'Carregando...' : 'Selecione uma marca'}
                </option>
                {marcas.map((marca) => (
                  <option
                    key={marca.id_marca || marca.ID_MARCA}
                    value={marca.id_marca || marca.ID_MARCA}
                  >
                    {marca.desc_marca || marca.DESC_MARCA}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>Unidade</Form.Label>
              <Form.Select
                name="UNIDADE"
                value={product.UNIDADE}
                onChange={(e) => handleChange(e, 'gerais')}
              >
                <option
                  defaultValue
                  value="UN"
                >
                  UN-UNITÁRIO
                </option>
                <option value="KIT">KIT-KIT</option>
              </Form.Select>
            </Col>

            <Col>
              <Form.Label>Formato</Form.Label>
              <Form.Select
                name="FORMATO"
                value={product.FORMATO}
                onChange={(e) => handleChange(e, 'gerais')}
              >
                <option value="S">SIMPLES</option>
                <option value="C">COM COMPOSIÇÃO</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Estoque Mínimo</Form.Label>
              <Form.Control
                name="ESTOQUEMINIMO"
                value={product.ESTOQUEMINIMO}
                onChange={(e) => handleChange(e, 'gerais')}
              />
            </Col>

            <Col>
              <Form.Label>Ativo/Inativo</Form.Label>
              {console.log(product.ATIVO)}
              <Form.Select
                name="ATIVO"
                value={product.ATIVO}
                onChange={(e) => handleChange(e, 'gerais')}
                disabled={localStorage.admin !== 'SIM'}
              >
                <option value="ATIVO">ATIVO</option>
                <option value="INATIVO">INATIVO</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col
              style={{
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <Form.Check
                name="PROD_EMBALAGEM"
                label="Embalagem"
                checked={
                  // eslint-disable-next-line no-constant-condition
                  product.PROD_EMBALAGEM === null ? false : true
                }
                onChange={() => {
                  setProduct((prevState) => ({
                    ...prevState,
                    gerais: {
                      ...prevState.gerais,
                      PROD_EMBALAGEM:
                        product.PROD_EMBALAGEM === null ? 'S' : null,
                    },
                  }))
                }}
              />
            </Col>

            <Col
              style={{
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <Form.Check
                name="APTO_GERACAO"
                label="Não Permitir Faturamento"
                checked={product.APTO_GERACAO === null ? false : true}
                onChange={() => {
                  setProduct((prevState) => ({
                    ...prevState,
                    gerais: {
                      ...prevState.gerais,
                      APTO_GERACAO: product.APTO_GERACAO === null ? 'S' : null,
                    },
                  }))
                }}
              />
            </Col>

            <Col>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
              >
                <Form.Label
                  style={{
                    margin: 0,
                  }}
                >
                  Conta
                </Form.Label>

                {isLoadingContas && <CustomSpinner size={18} />}
              </div>
              <Form.Select
                value={product.ID_CONTA}
                name="ID_CONTA"
                onChange={(e) => handleChange(e, 'gerais')}
                disabled={isLoadingContas}
                style={{
                  marginTop: 8,
                }}
              >
                <option value="">
                  {isLoadingContas ? 'Carregando...' : 'Selecione uma conta'}
                </option>
                {contas.map((conta) => (
                  <option
                    key={conta.ID_CONTA}
                    value={conta.ID_CONTA}
                  >
                    {conta.APELIDO}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </ContentComponent>

        <FooterComponent>
          <OverlayTrigger overlay={<Tooltip>Avançar</Tooltip>}>
            <NextButton onClick={onNext}>
              <ArrowRightCircleFill
                size={15}
                color="white"
              />
            </NextButton>
          </OverlayTrigger>
        </FooterComponent>
      </div>
    </ContainerComponent>
  )
}
